/* 
Allows the connected wallet to withdraw accrued Eth fees
*/
import { Stack, Button, TextInput, Group, Select } from "@mantine/core";
import { useState } from "react";
import EthAddress from "../../EthAddress/EthAddress";

export default function SetOrchestrator(props) {
  const [thisTextValue, setThisValue] = useState("");
  const [thisSearchValue, setThisSearchValue] = useState("");
  let thisSearchData = [];
  let thisInfo = null;
  // Get selected O
  let disabled = true;
  let thisAddr = "";
  if (thisTextValue.startsWith("0x") && thisTextValue.length == 42) {
    disabled = false;
    thisAddr = thisTextValue;
  }
  // Override with search value
  if (thisSearchValue.startsWith("0x") && thisSearchValue.length == 42) {
    disabled = false;
    thisAddr = thisSearchValue;
    thisSearchData.push({
      value: thisSearchValue,
      label: thisSearchValue
    })
  }
  // Retrieve info object of selected transcoder and fill data for search box
  let orchestrators = props.transcoderTable || [];
  for (var idx = 0; idx < orchestrators.length; idx++) {
    const transcoder = orchestrators[idx];
    if (transcoder.address == props.orchestratorAddr) {
      thisInfo = transcoder;
    }
    if (transcoder.address != thisSearchValue){
      thisSearchData.push({
        value: transcoder.address,
        label: transcoder.address,
      });
    }
  }
  return (
    <Stack spacing={24}>
      <Group position="center" spacing={24}>
        <EthAddress
          address={props.orchestratorAddr}
          cachedENS={props.cachedENS}
          preamble={"The currently selected Orchestrator is "}
        />
      </Group>
      <Group position="center" spacing={24}>
        <Select
          data={thisSearchData}
          label="Select Orchestrator"
          placeholder={props.orchestratorAddr}
          transition="pop-top-right"
          description="If you would like to stake to another Orchestrator, you can override the ETH address below. This is at your own risk!"
          transitionDuration={80}
          transitionTimingFunction="ease"
          value={thisTextValue}
          onChange={(event) => {
            setThisValue(event);
            if (event != thisSearchValue){
              setThisSearchValue(event);
            }
          }}
          onSearchChange={(event) => {
            setThisSearchValue(event);
            if (event.startsWith("0x") && event.length == 42) {
              setThisValue(event);
            }
          }}
          searchValue={thisSearchValue}
          nothingFound="Manual Entry"
          maxDropdownHeight={400}
          searchable
          radius="xs"
        />
      </Group>
      <Group position="center" spacing={24}>
        <Button
          radius="xs"
          uppercase
          disabled={disabled}
          variant="gradient"
          gradient={{ from: "#61892f", to: "#86c232", deg: 45 }}
          onClick={() => props.setOrchestrator(thisAddr)}
        >
          {disabled ? "Input a valid ETH address" : "Set to " + thisAddr}
        </Button>
      </Group>
    </Stack>
  );
}
